import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { TermsEntity } from '@/entities';

import { fetchMissingConsents } from './missing-consents';

import type {
  AcceptConsentsRequest,
  LangType,
  RequiredConsentsResponse,
  TermsAcceptRequest,
  TermsAcceptResponse,
  TermsType,
} from '@/entities/terms/types';

export const options = {
  rootKey: 'terms',
  getCurrentActivatedTerms: (termsType: TermsType = 'EULA', langType: LangType = 'KO') =>
    queryOptions({
      queryKey: [options.rootKey, 'currentActivated', termsType, langType],
      queryFn: () => TermsEntity.TermsRepository.getCurrentActivatedTerms(termsType, langType),
      staleTime: 1000 * 60 * 60,
    }),
  acceptTerms: () =>
    ({
      mutationKey: [options.rootKey, 'accept'],
      mutationFn: (params: TermsAcceptRequest) => TermsEntity.TermsRepository.acceptTerms(params),
    }) as UseMutationOptions<TermsAcceptResponse, Error, TermsAcceptRequest>,
  /** TRAD-3759 — 재동의 화면의 목록(게이트와 같은 함수). 동의 직후 다시 읽어야 하므로 캐시하지 않는다. */
  missingConsents: (langType: LangType) =>
    queryOptions({
      queryKey: [options.rootKey, 'missingConsents', langType],
      queryFn: () => fetchMissingConsents(langType),
      staleTime: 0,
    }),
  /** TRAD-3759 — 가입 화면(로그인 전)의 필수 동의 행. langType 은 서버 displayName(모르는 종류 폴백)의 언어라 키에 넣는다. */
  requiredConsents: (langType: LangType) =>
    queryOptions({
      queryKey: [options.rootKey, 'requiredConsents', langType],
      queryFn: () => TermsEntity.TermsRepository.getRequiredConsents(),
      staleTime: 0,
    }),
  acceptConsents: () =>
    ({
      mutationKey: [options.rootKey, 'acceptConsents'],
      mutationFn: (params: AcceptConsentsRequest) => TermsEntity.TermsRepository.acceptConsents(params),
    }) as UseMutationOptions<RequiredConsentsResponse, Error, AcceptConsentsRequest>,
};
